import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { PrototypeProvider } from './mock/store'
import { router } from './router'
import { ToasterProvider } from './shell/toaster'
import './styles.css'

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element #root is missing from index.html')

createRoot(rootElement).render(
  <StrictMode>
    <PrototypeProvider>
      <ToasterProvider>
        <RouterProvider router={router} />
      </ToasterProvider>
    </PrototypeProvider>
  </StrictMode>,
)
